export function notNullOrUndefined<T>(input: T): input is NonNullable<T> {
	return input !== null && input !== undefined;
}
